import { StressAndStabilityAtSea } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const STRESS_AND_STABILITY_AT_SEA_DATA_TAG = 'StressAndStabilityAtSea';
export default class StressAndStabilityAtSeaParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.AT_SEA_STRESS_AND_STABILITY, FIXED_PROTOCOL_CONTENT_TYPE_IDS.AT_SEA_STRESS_AND_STABILITY, STRESS_AND_STABILITY_AT_SEA_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            draftForward: 'draftForward',
            draftMidship: 'draftMidship',
            draftAft: 'draftAft',
            draftMeasurementPositionForward: 'draftMeasurementPositionForward',
            draftMeasurementPositionMidship: 'draftMeasurementPositionMidship',
            draftMeasurementPositionAft: 'draftMeasurementPositionAft',
            waterDensity: 'waterDensity',
            gzCurve: 'gzCurve',
            rightingLeverGz: 'rightingLeverGz',
            gm: 'gm',
            shearForces: 'shearForces',
            bending: 'bending',
            torsion: 'torsion',
            loadlineZone: 'loadlineZone',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new StressAndStabilityAtSea(props.draftForward, props.draftMidship, props.draftAft, props.draftMeasurementPositionForward, props.draftMeasurementPositionMidship, props.draftMeasurementPositionAft, props.waterDensity, props.gzCurve, props.rightingLeverGz, props.gm, props.shearForces, props.bending, props.torsion, props.loadlineZone, props.freeText);
    }
}
//# sourceMappingURL=StressAndStabilityAtSeaParser.js.map